export default "__VITE_ASSET__fa_7HDvk__"